var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 1.49273,
    y: 1.19423,
    width: 6.33494,
    height: 6.33494,
    rx: 1.33126,
    stroke: "white",
    strokeWidth: 1.00992
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 1.49265,
    y: 9.45705,
    width: 6.33494,
    height: 6.33494,
    rx: 1.33126,
    stroke: "white",
    strokeWidth: 1.00992
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 9.75565,
    y: 9.45705,
    width: 6.33494,
    height: 6.33494,
    rx: 1.33126,
    stroke: "white",
    strokeWidth: 1.00992
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 12.9231,
    cy: 4.36164,
    r: 3.16747,
    stroke: "white",
    strokeWidth: 1.00992
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.cdbadacc3479f39ac00228f953e4f7c2.svg";
export { ForwardRef as ReactComponent };